import axios from 'axios';

export const instructorApi = {
  getAll: (tenantId: string, activeOnly = true) => {
    return axios.get(`/api/instructors/tenant/${tenantId}`, {
      params: { active_only: activeOnly },
    });
  },

  getOne: (tenantId: string, id: string) => {
    return axios.get(`/api/instructors/tenant/${tenantId}/${id}`);
  },

  create: (data: any) => {
    return axios.post('/api/instructors', data);
  },

  update: (tenantId: string, id: string, data: any) => {
    return axios.patch(`/api/instructors/tenant/${tenantId}/${id}`, data);
  },

  delete: (tenantId: string, id: string) => {
    return axios.delete(`/api/instructors/tenant/${tenantId}/${id}`);
  },

  deactivate: (tenantId: string, id: string) => {
    return axios.post(`/api/instructors/tenant/${tenantId}/${id}/deactivate`);
  },

  syncFromCanvas: (tenantId: string, canvasCourseId: string) => {
    return axios.post(`/api/instructors/tenant/${tenantId}/sync-from-canvas`, {
      canvas_course_id: canvasCourseId,
    });
  },
};
